// extracted by mini-css-extract-plugin
export default {"root":"plain-modal-container_root__T-mga","placeHolderShimmer":"plain-modal-container_placeHolderShimmer__dv7Jn"};